// components/Testimonials.js
import React from 'react'
import SectionHeadingWrapper from '../HomePage/SectionHeadingWrapper'
import SectionHeading from '../HomePage/SectionHeading'
import Slider from 'react-slick'

const testimonials = [
    {
        quote: "Using their Premium List Building service has transformed our marketing strategy. The quality of the lists is outstanding, and we've seen a significant increase in successful deals.",
        name: 'John D.',
    },
    {
        quote: 'The personalized approach made all the difference. They understood our needs and provided us with a list that perfectly matched our criteria. Highly recommend!',
        name: 'Emily R.',
    },
    {
        quote: 'The Premium List Building service helped me find the perfect investment opportunities. The customized list was exactly what I needed to boost my marketing performance.',
        name: 'John D.',
    },
    {
        quote: 'The coaching calls provided invaluable guidance. I highly recommend this service to anyone looking to improve their list-building efforts.',
        name: 'Sarah W.',
    },
]

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
        {
            breakpoint: 768, // Adjust this value based on your needs
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
}

const Testimonials = () => {
    return (
        <div className="md:p-20 px-10 md:py-28 py-16 bg-light-yellow-gradient rounded-10xl md:rounded-8xl">
            <div className="max-w-7xl mx-auto">
                <SectionHeadingWrapper>
                    <SectionHeading>Testimonials</SectionHeading>
                </SectionHeadingWrapper>
                {/* <div className="mt-12 grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"> */}

                <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="px-4">
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <div className="flex items-center mb-4">
                                    <svg
                                        className="w-6 h-6 text-yellow-500"
                                        fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path d="M12 .587l3.668 7.429 8.2 1.2-5.927 5.78 1.4 8.167L12 18.897l-7.341 3.866 1.4-8.167-5.927-5.78 8.2-1.2L12 .587z" />
                                    </svg>
                                    <svg
                                        className="w-6 h-6 text-yellow-500"
                                        fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path d="M12 .587l3.668 7.429 8.2 1.2-5.927 5.78 1.4 8.167L12 18.897l-7.341 3.866 1.4-8.167-5.927-5.78 8.2-1.2L12 .587z" />
                                    </svg>
                                    <svg
                                        className="w-6 h-6 text-yellow-500"
                                        fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path d="M12 .587l3.668 7.429 8.2 1.2-5.927 5.78 1.4 8.167L12 18.897l-7.341 3.866 1.4-8.167-5.927-5.78 8.2-1.2L12 .587z" />
                                    </svg>
                                    <svg
                                        className="w-6 h-6 text-yellow-500"
                                        fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path d="M12 .587l3.668 7.429 8.2 1.2-5.927 5.78 1.4 8.167L12 18.897l-7.341 3.866 1.4-8.167-5.927-5.78 8.2-1.2L12 .587z" />
                                    </svg>
                                    <svg
                                        className="w-6 h-6 text-yellow-500"
                                        fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path d="M12 .587l3.668 7.429 8.2 1.2-5.927 5.78 1.4 8.167L12 18.897l-7.341 3.866 1.4-8.167-5.927-5.78 8.2-1.2L12 .587z" />
                                    </svg>
                                </div>
                                <p className="text-gray-700 mb-4">
                                    {testimonial.quote}
                                </p>
                                <p className="font-bold">{testimonial.name}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
            {/* </div> */}
        </div>
    )
}

export default Testimonials
